import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/common/components/ui/card";

export const EmptyState = () => {
  return (
    <Card className="border border-border/50">
      <CardContent className="py-16 text-center">
        <AlertCircle className="mx-auto mb-4 h-16 w-16 text-muted-foreground/30" />
        <h3 className="mb-2 text-lg font-semibold text-[#1D2C56]">
          No News Found
        </h3>
        <p className="text-muted-foreground">
          No news articles found for your search. Try adjusting the keywords or
          category.
        </p>
      </CardContent>
    </Card>
  );
};
